import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setUser = 'SET_USER',
  resetUser = 'RESET_USER',
  setToast = 'SET_TOAST',
  setPermissions = 'SET_PERMISSIONS',
  resetPermissions = 'RESET_PERMISSIONS',
  setRouteConfig = 'SET_ROUTE_CONFIG',
  setNavbarState = 'SET_NAVBAR',
  setLayout = 'SET_LAYOUT'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
